import { InjectionToken } from '@angular/core';

import type { SocketIoConfig } from './socket-io.model';

export const SOCKET_CONFIG_TOKEN = new InjectionToken<SocketIoConfig>('__SOCKET_IO_CONFIG__');
